<template>
  <v-row class="px-2">
    <v-col cols="12" sm="12" md="12" class="text-center font-weight-bold d-print-block">
      Статистика  полученных писем  по регионам с
      <template>
        {{ startFilterDisplayValue }}
      </template>
      по
      <template>
        {{ endFilterDisplayValue }}
      </template>
    </v-col>
    <v-col cols="12" md="2" class="d-flex align-center justify-center justify-md-end d-print-none">
      <v-select v-model="filters.isAllClientsSelected"
                :items="filterOptions"
                label="Выбрать все организации"

      />
    </v-col>
    <v-col cols="12" md="4" class="d-print-none">
      <v-select
          :disabled="filters.isAllClientsSelected"
          v-model="filters.clients"
          :items="clientsOptions()"
          label="Выберите организации"
          multiple
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index < 2" small style="background-color: #111; color: white; border-radius: 10px">
            <span>{{ item.text }}</span>
          </v-chip>
          <span
              v-if="index === 2"
              class="text-grey text-caption align-self-center"
          >
          (+{{ filters.clients.length - 2 }} другие)
          </span>
        </template>
      </v-select>
    </v-col>
    <v-col cols="12" sm="3"  md="2" class="d-flex align-center justify-center justify-md-end d-print-none">
      <v-select v-model="filters.isArchive"
                :items="archiveOptions"
                label="Выбрать версию"
      />
    </v-col>
    <v-col cols="12" md="2" class="d-print-none d-flex align-center justify-center justify-md-end">
      <v-menu
          v-model="filterStartMenu"
          transition="scale-transition"
          offset-y
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
      >
        <template v-slot:activator="{on}">
          <v-text-field
              label="Начало пероида"
              v-model="startFilterDisplayValue"
              readonly
              v-on="on"
              flat

          />

        </template>
        <v-date-picker
            v-model="filters.start"
            @change="onFilterStartChanged"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
            :allowed-dates="(date) => {
              if (this.allowedFullAccessToPeriod) {
                return true
              }

              const currentDate = new Date();
              const lastMonth = new Date();
              lastMonth.setMonth(currentDate.getMonth() - -1);
              const secondToLastMonth = new Date();
              secondToLastMonth.setMonth(currentDate.getMonth() - 2);

              return date <= lastMonth.toISOString().substr(0, 7) &&
              date >= secondToLastMonth.toISOString().substr(0, 7)&&
              date <= new Date().toISOString().substr(0, 10);
            }"
        />
      </v-menu>
    </v-col>
    <v-col cols="12" md="2" class="d-print-none d-flex align-center justify-center justify-md-end">
      <v-menu
          v-model="filterEndMenu"
          transition="scale-transition"
          offset-y
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
      >
        <template v-slot:activator="{on}">
          <v-text-field
              label="Конец пероида"
              v-model="endFilterDisplayValue"
              readonly

              v-on="on"
              flat
          />
        </template>
        <v-date-picker
            v-model="filters.end"
            @change="onFilterEndChanged"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
            :allowed-dates="(date) => {
              if (this.allowedFullAccessToPeriod) {
                return true
              }

              const currentDate = new Date();
              const lastMonth = new Date();
              lastMonth.setMonth(currentDate.getMonth() - -1);
              const secondToLastMonth = new Date();
              secondToLastMonth.setMonth(currentDate.getMonth() - 2);

              return date <= lastMonth.toISOString().substr(0, 7) &&
              date >= secondToLastMonth.toISOString().substr(0, 7) &&
              date <= new Date().toISOString().substr(0, 10);
            }"
        />
      </v-menu>
    </v-col>
    <v-col cols="12" md="12" class="d-flex justify-end d-print-none">
      <v-btn @click="onRefreshClicked" color="primary me-2" large :disabled="disableRefreshButton" >Обновить</v-btn>
      <v-btn @click="onPrintClicked" color="primary" large>Распечатать</v-btn>
    </v-col>
    <v-col cols="12">
      <template>
        <table>
          <thead>
          <tr style="background-color: aliceblue;">
            <th rowspan="2">Регион</th>
            <th rowspan="2" class="text-center filter-header">Принято за период</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(2) }" :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(2)" class="text-center filter-header">Распечатано за период из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(3) }" :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(3)" class="text-center filter-header">Остаток к концу периода из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(4) }" :style="{ backgroundColor: filters.selectedFilters.includes(4) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(4)" class="text-center filter-header">Досылов за период из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(5) }" :style="{ backgroundColor: filters.selectedFilters.includes(5) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(5)" class="text-center filter-header">Сформировано за период из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(6) }" :style="{ backgroundColor: filters.selectedFilters.includes(6) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(6)" class="text-center filter-header">Вручено из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(7) }" :style="{ backgroundColor: filters.selectedFilters.includes(7) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(7)" class="text-center filter-header">Возврат из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(11) }" :style="{ backgroundColor: filters.selectedFilters.includes(11) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(11)" class="text-center filter-header">Попытка вручения</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(8) }" :style="{ backgroundColor: filters.selectedFilters.includes(8) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(8)" class="text-center filter-header">Нет результата из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(9) }" :style="{ backgroundColor: filters.selectedFilters.includes(9) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(9)" class="text-center filter-header">Просроченные из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(10) }" :style="{ backgroundColor: filters.selectedFilters.includes(10) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(10)" class="text-center filter-header">Доставленные после возврата</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item.region.id">
            <v-btn :class="{ 'd-print-none': !filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: filters.selectedRegions.includes(item.region.id) ? 'aliceblue' : '#e5e5e5' }" @click="toggleRegion(item.region.id)" class="d-flex justify-space-between" style="height: 40px; width: 100%; background-color: aliceblue; border: 1px solid black; text-align: center">
              {{ item.region.name }}
              <router-link class="d-print-none" style="text-decoration: none; color: black" :to="{name: 'report-processing-area', params: {regionId: item.region.id, filters: filters}}">
                <v-icon>mdi-import</v-icon>
              </router-link>
            </v-btn>
            <td :class="{ 'd-print-none': !filters.selectedRegions.includes(item.region.id), 'column': filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedRegions.includes(item.region.id) ? '#e5e5e5' : '' }" @click="itemClicked(1, item.region.id, item.received)">{{ filters.selectedRegions.includes(item.region.id) ? (item.received ? item.received : 0) : null}}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(2), 'column': filters.selectedFilters.includes(2) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(2) || !filters.selectedRegions.includes(item.region.id) ? '#e5e5e5' : '' }" @click="itemClicked(2, item.region.id, item.printedForPeriodNormal)">{{ filters.selectedFilters.includes(2) && filters.selectedRegions.includes(item.region.id) ? (item.printedForPeriodNormal ? item.printedForPeriodNormal : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(3), 'column': filters.selectedFilters.includes(3) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(3) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(3, item.region.id, item.restForPeriodEnd)">{{ filters.selectedFilters.includes(3) && filters.selectedRegions.includes(item.region.id) ? (item.restForPeriodEnd ? item.restForPeriodEnd : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(4), 'column': filters.selectedFilters.includes(4) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(4) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(4, item.region.id, item.deletedFromPostPackageCount)">{{ filters.selectedFilters.includes(4) && filters.selectedRegions.includes(item.region.id) ? (item.deletedFromPostPackageCount ? item.deletedFromPostPackageCount : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(5), 'column': filters.selectedFilters.includes(5) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(5) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(5, item.region.id, item.postPackedForPeriod)">{{ filters.selectedFilters.includes(5) && filters.selectedRegions.includes(item.region.id) ? (item.postPackedForPeriod ? item.postPackedForPeriod : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(6), 'column': filters.selectedFilters.includes(6) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(6) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(6, item.region.id, item.deliveredFromPacked)">{{ filters.selectedFilters.includes(6) && filters.selectedRegions.includes(item.region.id) ? (item.deliveredFromPacked ? item.deliveredFromPacked : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(7), 'column': filters.selectedFilters.includes(7) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(7) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(7, item.region.id, item.returnedFromPacked)">{{ filters.selectedFilters.includes(7) && filters.selectedRegions.includes(item.region.id) ? (item.returnedFromPacked ? item.returnedFromPacked : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(11), 'column': filters.selectedFilters.includes(11) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(11) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(11, item.region.id, item.tryPerform)">{{ filters.selectedFilters.includes(11) && filters.selectedRegions.includes(item.region.id) ? (item.tryPerform ? item.tryPerform : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(8), 'column': filters.selectedFilters.includes(8) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(8) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(8, item.region.id, item.postPackedNotPerformed)">{{ filters.selectedFilters.includes(8) && filters.selectedRegions.includes(item.region.id) ? (item.postPackedNotPerformed ? item.postPackedNotPerformed : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(9), 'column': filters.selectedFilters.includes(9) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(9) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(9, item.region.id, item.expiredCount)">{{ filters.selectedFilters.includes(9) && filters.selectedRegions.includes(item.region.id) ? (item.expiredCount ? item.expiredCount : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(10), 'column': filters.selectedFilters.includes(10) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(10) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(10, item.region.id, item.successDeliveredAfterFailedCount)">{{ filters.selectedFilters.includes(10) && filters.selectedRegions.includes(item.region.id) ? (item.successDeliveredAfterFailedCount ? item.successDeliveredAfterFailedCount : 0) : null }}</td>
          </tr>
          <tr style="background-color: aliceblue; color: black; font-weight: bold">
            <td style="height: 40px; text-align: center">Общее</td>
            <td>{{ totals.received }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(2) }" :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(2) ? (totals.printedForPeriodNormal ? totals.printedForPeriodNormal : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(3) }" :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(3) ? (totals.restForPeriodEnd ? totals.restForPeriodEnd : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(4) }" :style="{ backgroundColor: filters.selectedFilters.includes(4) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(4) ? (totals.deletedFromPostPackageCount ? totals.deletedFromPostPackageCount : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(5) }" :style="{ backgroundColor: filters.selectedFilters.includes(5) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(5) ? (totals.postPackedForPeriod ? totals.postPackedForPeriod : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(6) }" :style="{ backgroundColor: filters.selectedFilters.includes(6) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(6) ? (totals.deliveredFromPacked ? totals.deliveredFromPacked : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(7) }" :style="{ backgroundColor: filters.selectedFilters.includes(7) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(7) ? (totals.returnedFromPacked ? totals.returnedFromPacked : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(11) }" :style="{ backgroundColor: filters.selectedFilters.includes(11) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(11) ? (totals.tryPerform ? totals.tryPerform : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(8) }" :style="{ backgroundColor: filters.selectedFilters.includes(8) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(8) ? (totals.postPackedNotPerformed ? totals.postPackedNotPerformed : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(9) }" :style="{ backgroundColor: filters.selectedFilters.includes(9) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(9) ? (totals.expiredCount ? totals.expiredCount : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(10) }" :style="{ backgroundColor: filters.selectedFilters.includes(10) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(10) ? (totals.successDeliveredAfterFailedCount ? totals.successDeliveredAfterFailedCount : 0) : null }}</td>
          </tr>
          </tbody>
        </table>
        <v-dialog v-model="showModal" :persistent="true" width="1000px">
          <BranchRegionMailsModal ref="branchRegionMailsModal" @close-modal="closeModal"/>
        </v-dialog>
      </template>
    </v-col>
    <v-snackbar
        v-if="disableRefreshButton"
        :timeout="-1"
        :value="true"
        absolute
        bottom
        color="red"
        right
    >
      Дату можно выбрать в пределах одного месяца
    </v-snackbar>
  </v-row>
</template>

<script>
import Moment from 'moment'
import _ from "underscore";
import {required} from 'vuelidate/lib/validators'
import {DateLimitForFilters} from "@/settings/server";
import BranchRegionMailsModal from "@/components/report/BranchStatistics/Modals/BranchRegionMailsModalComponent.vue";
import {clients} from "@/helpers/constants";

export default {
  name: "BranchRegionReportComponent",
  components: {BranchRegionMailsModal},
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      filters: {
        start: null,
        end: null,
        date: null,
        selectedFilters: [],
        selectedRegions: [this.$store.getters.appLogin.regions[0].id],
        isAllClientsSelected: false,
        isArchive: 1,
        clients: []
      },
      showModal: false,
      mails: [],
      archiveOptions: [
        { text: '1', value: 1 }
      ],
      filterOptions: [
        { text: 'Нет', value: false },
        { text: 'Да', value: true },
      ],
      startFilterDisplayValue: null,
      endFilterDisplayValue: null,
      filterStartMenu: false,
      filterEndMenu: false,
      dateFilterDisplayValue: null,
      filterDateMenu: false,
    }
  },
  computed: {
    totals() {
      let received = 0;
      let printedForPeriodNormal = null;
      let restForPeriodEnd = null;
      let deletedFromPostPackageCount = null;
      let postPackedForPeriod = null;
      let deliveredFromPacked = null;
      let returnedFromPacked = null;
      let postPackedNotPerformed = null;
      let expiredCount = null;
      let successDeliveredAfterFailedCount = null;
      let tryPerform = null;

      _.each(this.items, item => {
        received += item.received ? item.received : 0;
        if(item.printedForPeriodNormal !== null)
          printedForPeriodNormal += item.printedForPeriodNormal
        if(item.restForPeriodEnd !== null)
          restForPeriodEnd += item.restForPeriodEnd
        if(item.deletedFromPostPackageCount !== null)
          deletedFromPostPackageCount += item.deletedFromPostPackageCount
        if(item.postPackedForPeriod !== null)
          postPackedForPeriod += item.postPackedForPeriod
        if(item.deliveredFromPacked !== null)
          deliveredFromPacked += item.deliveredFromPacked
        if(item.tryPerform !== null)
          tryPerform += item.tryPerform
        if(item.returnedFromPacked !== null)
          returnedFromPacked += item.returnedFromPacked
        if(item.postPackedNotPerformed !== null)
          postPackedNotPerformed += item.postPackedNotPerformed
        if(item.expiredCount !== null)
          expiredCount += item.expiredCount
        if(item.successDeliveredAfterFailedCount !== null)
          successDeliveredAfterFailedCount += item.successDeliveredAfterFailedCount
      });

      return {
        received: received,
        printedForPeriodNormal: printedForPeriodNormal,
        restForPeriodEnd: restForPeriodEnd,
        deletedFromPostPackageCount: deletedFromPostPackageCount,
        postPackedForPeriod: postPackedForPeriod,
        deliveredFromPacked: deliveredFromPacked,
        returnedFromPacked: returnedFromPacked,
        postPackedNotPerformed: postPackedNotPerformed,
        expiredCount: expiredCount,
        tryPerform: tryPerform,
        successDeliveredAfterFailedCount: successDeliveredAfterFailedCount,
      }
    },
    disableRefreshButton() {
      if (this.allowedFullAccessToPeriod === true) {
        return false
      }

      return this.isAllowedReload() || this.$v.$invalid
    },
    allowedFullAccessToPeriod() {
      const allowedUserIds = [1,10,11,30,44,45,67,225,227,262,931,1009,1027,1554,1722,2158,2196,17480,18260];

      if (allowedUserIds.includes(this.$store.getters.appLogin.id)) {
        return true;
      }
      return false;
    }
  },
  validations: {
    filters: {
      start: {
        required
      },
      end: {
        required
      }
    }
  },
  methods: {
    clientsOptions() {
      return clients
    },
    closeModal() {
      this.showModal = false;
    },
    itemClicked(filter, region, count){
      if(filter && region && count){
        this.showModal = true;

        this.$nextTick(() => {
          this.$refs.branchRegionMailsModal.set(filter, region, this.filters, count, "Статистика филиалов по регионам");
        });
      }
    },
    toggleFilter(filterId) {
      const index = this.filters.selectedFilters.findIndex(id => id === filterId);
      if (index !== -1) {
        this.filters.selectedFilters.splice(index, 1);
      } else {
        this.filters.selectedFilters.push(filterId);
      }
    },
    toggleRegion(regionId) {
      const index = this.filters.selectedRegions.findIndex(id => id === regionId);
      if (index !== -1) {
        this.filters.selectedRegions.splice(index, 1);
      } else {
        this.filters.selectedRegions.push(regionId);
      }
    },
    isAllowedReload() {
      const startDate = this.filters.start;
      const endDate = this.filters.end;

      if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        const dayDifference = (end - start) / (1000 * 60 * 60 * 24);

        if (dayDifference > DateLimitForFilters) {
          return true;
        }
      }
    },
    updateItems() {
      this.$emit('updated', this.filters)
    },
    onRefreshClicked() {
      this.updateItems()
    },
    onFilterStartChanged() {
      if (this.filters.start) {
        this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterStartMenu = false
    },
    onFilterEndChanged() {
      if (this.filters.end) {
        this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterEndMenu = false
    },

    onFilterDateChanged() {
      if (this.filters.date) {
        this.dateFilterDisplayValue = Moment(this.filters.date, 'YYYY-MM').format('MM.YYYY')
      }

      this.filterDateMenu = false
    },

    onPrintClicked() {
      window.print()
    }
  },
  created() {
    this.filters.selectedFilters = this.$route.params?.filters?.selectedFilters || [];
    this.filters.selectedRegions = this.$route.params?.filters?.selectedRegions || [this.$store.getters.appLogin.regions[0].id];
    this.filters.start = this.$route.params?.filters?.start ?? Moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.filters.end = this.$route.params?.filters?.end ?? Moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.filters.isArchive = this.$route.params?.filters?.isArchive
    this.filters.isAllClientsSelected = this.$route.params?.filters?.isAllClientsSelected

    this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
    this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')

    this.updateItems();
  }
}
</script>

<style scoped>
.filter-header {
  padding: 5px;
  border-radius: 5px;
  font-size: 15px;
  cursor: pointer;
}

.filter-header:hover{
  background-color: #e5e5e9;
}

.column {
  padding: 5px;
  border-radius: 5px;
  font-size: 15px;
  cursor: pointer;
}

.column:hover{
  background-color: #dfe7ed;
}
th {
  text-align: center;
  border-right: 2px solid black;
  border-bottom: 2px solid black !important;
}

tr th:first-child {
  border-left: 2px solid black;
}

tr:nth-child(2) th:first-child {
  border-left: 0;
}

tr:first-child th {
  border-top: 2px solid black;
}

td {
  text-align: center;
  border-right: 1px solid #253d6d;
  border-bottom: 1px solid #253d6d;
}

td:first-child {
  text-align: left;
  border-left: 1px solid #253d6d;
}

@media print {
  td, th {
    padding: 0 5px !important;
    margin: 0 !important;
  }

  table {
    page-break-inside: auto
  }

  tr {
    page-break-inside: avoid;
    page-break-after: auto
  }
}
</style>
